import React from "react";
import { useTrapSkuStore } from "../../stores/trapSkuStore";
import { useTrapsSelectionStore } from "../../stores/trapsSelectionStore";

// Конфігурація заголовків таблиці
const headersConfig = [
  { label: "Товарів", sortKey: "product_count" },
  { label: "Фото", sortKey: null },
  { label: "Назва товару", sortKey: "product_name" },
  { label: "Магазин", sortKey: "shop_name" },
  { label: "Артикул (SKU)", sortKey: "sku" },
  { label: "Категорія пастки", sortKey: "trap_category_name" },
  { label: "Ціна пастки", sortKey: "price" },
  { label: "Присутність", sortKey: "presence" },
  { label: "Авто", sortKey: null },
  { label: "", sortKey: null, className: "action-col" },
];

// Компонент заголовків таблиці товарів ловушок
const TrapSkuTableHeader = () => {
  // Отримуємо дані та дії зі стору ловушок
  const filters = useTrapSkuStore((state) => state.filters);
  const setSort = useTrapSkuStore((state) => state.setSort);
  // Отримуємо дані та дії зі стору вибору ловушок
  const isSelectionModeActive = useTrapsSelectionStore(
    (state) => state.isSelectionModeActive,
  );

  return (
    <thead>
      <tr>
        {isSelectionModeActive && <th className="selection-column"></th>}
        {headersConfig.map(({ label, sortKey, className }, idx) => (
          <th
            key={label || `col-${idx}`}
            className={`${sortKey ? "clickable" : ""} ${className || ""}`}
            onClick={sortKey ? () => setSort(sortKey) : undefined}
          >
            {label}
            {sortKey === filters.sort_by && (filters.sort_asc ? " ▲" : " ▼")}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TrapSkuTableHeader;
